import React from "react";
import PropTypes from "prop-types";

const ClipboardIcon = ({
  width,
  height,
  className,
  color,
  stroke,
  strokeWidth,
  ...props
}) => {
  const strokeColor =
    stroke && stroke !== "currentColor" ? stroke : color || "#94A3B8";

  return (
    <svg
      width={width || 32}
      height={height || 32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M20 2.6665H12C11.2636 2.6665 10.6666 3.26346 10.6666 3.99984V6.6665C10.6666 7.40288 11.2636 7.99984 12 7.99984H20C20.7363 7.99984 21.3333 7.40288 21.3333 6.6665V3.99984C21.3333 3.26346 20.7363 2.6665 20 2.6665Z"
        stroke={strokeColor}
        strokeWidth={strokeWidth || "2.66667"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3334 5.3335H24C24.7073 5.3335 25.3856 5.61445 25.8857 6.11454C26.3858 6.61464 26.6667 7.29292 26.6667 8.00016V26.6668C26.6667 27.3741 26.3858 28.0524 25.8857 28.5524C25.3856 29.0525 24.7073 29.3335 24 29.3335H8.00004C7.2928 29.3335 6.61452 29.0525 6.11442 28.5524C5.61433 28.0524 5.33337 27.3741 5.33337 26.6668V8.00016C5.33337 7.29292 5.61433 6.61464 6.11442 6.11454C6.61452 5.61445 7.2928 5.3335 8.00004 5.3335H10.6667"
        stroke={strokeColor}
        strokeWidth={strokeWidth || "2.66667"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

ClipboardIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

ClipboardIcon.defaultProps = {
  width: undefined,
  height: undefined,
  className: "",
  color: undefined,
  stroke: undefined,
  strokeWidth: undefined,
};

export default ClipboardIcon;
